import { useEffect } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import { insertTrackableHTML } from 'js/utils/DOM.util';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

const html = gstId => `<script async src="https://www.googletagmanager.com/gtag/js?id=${gstId}"></script>\n`
    + '<script>\n'
    + '  window.dataLayer = window.dataLayer || [];\n'
    + '  function gtag(){dataLayer.push(arguments);}\n'
    + '  gtag(\'js\', new Date());\n'
    + `  gtag('config', '${gstId}');\n`
    + '</script>';

export const GoogleGlobalSiteTag = ({ config, tagName }) => {
    const { gstId } = config;

    useEffect(() => {
        if (gstId === '') {
            return;
        }

        return insertTrackableHTML({ selector: 'head', html: html(gstId),
            tagName, wrapperComment: 'Global site tag (gtag.js) - Google Analytics'
        });
    }, [gstId, tagName]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.googleGlobalSite]: GoogleGlobalSiteTag });
